import React, { useEffect } from "react";
import GridContainer from "../common/grid/GridContainer";
import GridItem from "../common/grid/GridItem";
import TextInput from "../common/textInput/TextInput";
import { COLOR_RED, VALIDATIONS } from "../../utils/constants/GlobalConstants";
import {
  DOCU_SIGN_STATUS,
  SIGNATURES_DC_INPUT_FORM,
  SIGNATURES_STORE_INPUT_FORM,
  STATUS,
} from "../../utils/constants/GlobalFormConstants";

const SignaturesInput = ({ remainingFields, onChange, errorMessages, username, debiDetails, setErrorMessages,editClicked }) => {
  const [formValues, setFormValues] = React.useState({ ...remainingFields || {} });
  const [strAgentStatus, setStrAgentStatus]= React.useState("");
  const [strAgentRemarks, setStrAgentRemarks]= React.useState("");
  const [dcAgentStatus, setdcAgentStatus]= React.useState("");
  const [dcAgentRemarks, setdcAgentRemarks]= React.useState("");
  const [signDateDC,setSignDateDC]=React.useState("");
  const [signDateStore,setSignDateStore]=React.useState("");
  

  const getApprovedStatus =React.useCallback((value)=>{
    let res = debiDetails?.docusignDetails?.filter(o => o.signerEmail ===  debiDetails?.debis[0][value]);
    let finalStatus;
    let signDate;
    if(res[0]?.mailStatus === DOCU_SIGN_STATUS.MAIL_TRIGGERED){
      finalStatus = DOCU_SIGN_STATUS.MAIL_TRIGGERED_VALUE
     } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.COMPLETED){
        finalStatus= DOCU_SIGN_STATUS.COMPLETED_VALUE
        signDate = res[0]?.lastUpdatedTs;
     } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.CREATED){
       finalStatus = value === "dcEmail" ? DOCU_SIGN_STATUS.CREATED_VALUE_DC :DOCU_SIGN_STATUS.CREATED_VALUE_STORE
     } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.DECLINED){
       finalStatus = DOCU_SIGN_STATUS.DECLINED_VALUE
     } else if(res[0]?.mailStatus === DOCU_SIGN_STATUS.SENT){
       finalStatus = DOCU_SIGN_STATUS.SENT_VALUE
     }
     let remarks= res[0]?.remarks;
    
    return {finalStatus,remarks,signDate}
  },[debiDetails])
  useEffect(() => {
    setFormValues((prevValues) => ({
      ...prevValues,
      ...remainingFields,
    }));
  }, [remainingFields]);
  useEffect(()=>{
    if(debiDetails){
       let obj = getApprovedStatus('dcEmail')
       setdcAgentStatus(obj.finalStatus);
       setdcAgentRemarks(obj.remarks)
       setSignDateDC(obj?.signDate);
       let obj1 = getApprovedStatus('storeAgentEmail')
       setStrAgentStatus(obj1.finalStatus);
       setStrAgentRemarks(obj1.remarks);
       setSignDateStore(obj?.signDate);
    }
  
  },[getApprovedStatus,debiDetails])

  const validateField = (key, value) => {
    const newErrors = { ...errorMessages };
    const mailFormat = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    if (!value) {
      delete newErrors[key];
    } else if (key === 'dcName' && value.length > 60) {
      newErrors.dcName = VALIDATIONS.DC_NAME_LENGTH;
    } else if (key === 'dcEmail') {
      if (value.length > 60) {
        newErrors.dcEmail = VALIDATIONS.DC_EMAIL_LENGTH;
      } else if (!mailFormat.test(value)) {
        newErrors.dcEmail = VALIDATIONS.DC_EMAIL_VALID;
      } else {
        delete newErrors.dcEmail;
      }
    } else if (key === 'storeAgent' && value.length > 60) {
      newErrors.storeAgent = VALIDATIONS.STORE_AGENT_LENGTH;
    } else if (key === 'storeAgentEmail') {
      if (value.length > 60) {
        newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL;
      } else if (!mailFormat.test(value)) {
        newErrors.storeAgentEmail = VALIDATIONS.STORE_AGENT_EMAIL_VALID;
      } else {
        delete newErrors.storeAgentEmail;
      }
    } else {
      delete newErrors[key];
    }
    setErrorMessages(newErrors);
  };

  const handleInputChange = (key, value) => {
    setFormValues((prev) => ({ ...prev, [key]: value }));
    onChange(key, value);
    validateField(key, value)
  }
  return (
    <div className="form-layout">
      {/* store section */}
      <GridContainer spacing={2}>
        <GridItem xs={12} sm={4} lg={4} md={4} xl={4}>
          {SIGNATURES_STORE_INPUT_FORM.map((data, key) => {
            return (
              <div
                key={(key + 1) * 987}
                className="margin-sm-bt">
                <TextInput
                  key={key * 987}
                  label={data.label}
                  testid={data.key}                    
                  disabled={!(username === debiDetails?.debis[0]?.createdBy)  || (debiDetails?.debis[0]?.statusReason === STATUS.OPEN) ||
                  (debiDetails?.debis[0]?.statusReason === STATUS.CLOSED) || 
                  !(debiDetails?.docusignDetails && debiDetails?.docusignDetails?.length === 0)
                  }
                  required={true}
                  type={data.type}
                  onChange={(e) => handleInputChange(data.key, e?.target?.value)}
                  value={formValues[data.key] || ""}
                />
                {errorMessages[data.key] && (
                  <div style={COLOR_RED}>
                    {errorMessages[data.key]}
                  </div>
                )}
              </div>
            );
          })}
        </GridItem>

        <GridItem xs={12} sm={8} lg={8} md={8} xl={8}>
        {editClicked ? "" : 
          <div className="flex-container flex-center">
          {strAgentStatus} {signDateStore && "on "+signDateStore} {strAgentRemarks && strAgentRemarks!== " " && "with remarks as "+strAgentRemarks+"."}
          </div>
         
        }
        </GridItem>
      </GridContainer>
      {/* dc section */}
      <GridContainer spacing={2} mt={2}>
        <GridItem xs={12} sm={4} lg={4} md={4} xl={4}>
          {SIGNATURES_DC_INPUT_FORM.map((data, index) => {
            return (
              <div
                key={(index + 1) * 765}
                className="margin-sm-bt">
                <TextInput
                  key={index * 765}
                  label={data.label}
                  testid={data.key}
                  disabled={!(username === debiDetails?.debis[0]?.createdBy)  || (debiDetails?.debis[0]?.statusReason === STATUS.OPEN) ||
                  (debiDetails?.debis[0]?.statusReason === STATUS.CLOSED)|| 
                  !(debiDetails?.docusignDetails && debiDetails?.docusignDetails?.length === 0)
                }
                  required={true}
                  type={data.type}
                  data-testid={`${index}-${data.section}-label`}
                  onChange={(e) => handleInputChange(data.key, e?.target?.value)}
                  value={formValues[data.key] || ""}
                />
                {errorMessages[data.key] && (
                  <div style={COLOR_RED}>
                    {errorMessages[data.key]}
                  </div>
                )}
              </div>
            );
          })}
        </GridItem>
        <GridItem
          xs={12} sm={8} lg={8} md={8} xl={8}>
             {editClicked ? "" : 
          <div className="flex-container flex-center">
          {dcAgentStatus} {signDateDC && "on "+signDateDC} {dcAgentRemarks && dcAgentRemarks !== " " && "with remarks as "+dcAgentRemarks+"."}
          </div>
         
        }
  
        </GridItem>
      </GridContainer>
    </div>
  );
};

export default SignaturesInput;
